
export default {
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    onScroll: {
      type: Function,
      default: null,
    },
    setSlide: {
      type: Number,
      default: null,
    },
    stopListener: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // selector: null,
      carouselTrack: null,
      slides: [],
      lastSlide: null,
      currentSlide: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
      this.updateSlide()
      this.carouselTrack.addEventListener('scroll', () => {
        this.updateSlide()
      })
    })
  },
  methods: {
    init() {
      this.slides = this.$slots?.default
      this.slides.forEach((x, i) => {
        if (x.elm.nodeName !== '#text') {
          // add class 'carousel-item' to each item for targeting
          x.elm.classList.add('carousel-item')
          // add data attr for index reference
          x.elm.setAttribute('data-carousel-index', i)
        }
      })

      this.carouselTrack = this.$refs?.carouselTrack
      this.lastSlide = this.slides[this.slides.length - 1]
    },
    changeSlide(i, cb) {
      // update slide
      this.carouselTrack?.scroll({
        left: Math.floor(
          this.carouselTrack?.scrollWidth * (i / this.slides.length)
        ),
      })
      cb && cb()
    },
    updateSlide() {
      // console.log('caoursel', this.carouselTrack.scrollLeft)
      this.currentSlide = Math.round(
        this.carouselTrack.scrollLeft / this.lastSlide.elm.clientWidth
      )

      // cb
      this.onScroll &&
        requestAnimationFrame(() => this.onScroll(this.currentSlide))
    },

    // setObserver() {
    //   // this.$refs.carouselTrack.addEventListener('scroll', (event) => {
    //   //   console.log(event)
    //   // })
    //   const elements = this.selector('.carousel-item')

    //   const options = {
    //     root: this.$refs.carouselTrack, // set document viewport as root
    //     rootMargin: '0px', // margin around root
    //     threshold: 0.5, // 1.0 means that when 100% of the target is visible
    //     // inside the root, then observer callback is invoked.
    //   }

    //   const observer = new IntersectionObserver((entries) => {
    //     entries.forEach((entry) => {
    //       // when next slide comes into view halfway
    //       if (entry.intersectionRatio >= 0.5) {
    //         this.onScroll(entry)
    //       }
    //     })
    //   }, options)

    //   elements.forEach((elt) => {
    //     observer.observe(elt)
    //   })
    // },
  },
}
